import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsAnalyticsDataViewDetailsRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-analytics-data-view-details',
	path: '/jira/servicedesk/assets/analytics/data-view/:dataViewId',
	exact: true,
};
